@if (
  data[type]['inputType'] === 'text' ||
  data[type]['inputType'] === 'multi-select' ||
  data[type]['inputType'] === 'single-select'
) {
  <app-inputs
    class="w-100"
    [Label]="''"
    [tags]="data[type]['tags'] || []"
    [conditionLabel]="data[type]['conditionLabel']"
    [type]="data[type]['inputType']"
    [active]="false"
    [multiSelectTags]="data[type]['multiSelectTags']"
    [dropdown]="data[type]['dropdown']"
    [multiSelect]="data[type]['multiSelect']"
    [optionPlaceholder]="'select option...'"
    [stepCounter]="data[type]['stepCounter']"
    [placeholder]="data[type]['placeholder']"
    [prefix]="data[type]['prefix']"
    [suffix]="data[type]['sufix']"
    (onChange)="onChange.emit($event)"
    [prefixBadge]="data[type]['prefixContent']"
    [suffixBadge]="data[type]['sufixContent']"
    [warn]="false"
    [state]="data[type]['state']"
    [value]="data[type]['value']">
  </app-inputs>
}

@if (data[type]['inputType'] === 'image') {
  <app-file [state]="'default'"> </app-file>
}

@if (data[type]['inputType'] === 'files') {
  <app-file [state]="'default'"> </app-file>
}

@if (data[type]['inputType'] === 'currency') {
  <app-inputs
    [prefix]="true"
    [prefixBadge]="prefixConfig"
    [Label]="''"
    [placeholder]="data[type]['placeholder']"
    (onChange)="onChange.emit($event)"></app-inputs>
}
